import styled from "styled-components";

export const NotificationTicketDividerContainer = styled.div`
  --border-width: 2px;
  --border-color: ${({ theme }) => theme.notification.contentBorderColor};
  --border-invisible: ${({ theme }) => theme.groups.topBarGroupsBackground};

  border-bottom: var(--border-width) dashed var(--border-color);
  width: 100%;
  position: relative;

  margin: 0.75rem 0;

  ::before,
  ::after {
    content: "";
    position: absolute;
  }
`;
